<template>
<div class="chapter">
<div class="inner_page">
<div id="a02_title">
<p class="title">FROM THE</p>
<p class="title1">DREADNOUGHT</p>
<p class="title3">TO</p>
<p class="title1">SCAPA FLOW</p>
<p class="title2">The Royal Navy in the Fisher Era 1904–1919</p>
<p class="title4">VOLUME III<br/>JUTLAND AND AFTER: MAY TO DECEMBER1916</p>
<p class="author">ARTHUR J MARDER</p>
<p class="author1">INTRODUCTION BY BARRY GOUGH</p>
<p class="publisher">Naval Institute Press</p>
<p class="publoc">Annapolis</p>
<p class="img1"><img alt="image" src="images/plogo.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_title.vue?234bc53e